function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "82.476 20.461 330.714 440.952",
    height: 28,
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 230.839 452.516 C 105.703 271.107 82.476 252.488 82.476 185.818 C 82.476 94.493 156.508 20.461 247.833 20.461 C 339.157 20.461 413.19 94.493 413.19 185.818 C 413.19 252.488 389.962 271.107 264.827 452.516 C 256.615 464.379 239.05 464.378 230.839 452.516 Z M 247.833 254.716 C 285.885 254.716 316.731 223.87 316.731 185.818 C 316.731 147.766 285.885 116.919 247.833 116.919 C 209.781 116.919 178.934 147.766 178.934 185.818 C 178.934 223.87 209.781 254.716 247.833 254.716 Z",
    style: {
      fill: "rgb(0, 49, 115)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(145, 197, 237)"
    },
    cx: 247.415,
    cy: 184.531,
    r: 71.432,
    transform: "matrix(0.97597, 0, 0, 1.000324, 6.253172, 1.781676)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMap);
export default __webpack_public_path__ + "static/media/location_map.fb5bdbf37d19f28ef046c020052f9a57.svg";
export { ForwardRef as ReactComponent };